RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Metrics = RivalIQ.metrics.descriptions;

    function getMetricGroups(companyId, type) {
        type = type || 'impressions';
        const prefix = {
            insta_followers: 'INSTAGRAM_INSIGHTS_FOLLOWERS_GENDER_AGE_',
            page_reach_age_gender: 'FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_',
            page_fans_age_gender: 'FACEBOOK_INSIGHTS_PAGE_FAN_GENDER_AGE_'
        }[type];

        const groups = [
            {
                label: '13-17',
                metrics: [
                    Metrics[`${prefix}F13_17`].id,
                    Metrics[`${prefix}M13_17`].id
                ]
            },
            {
                label: '18-24',
                metrics: [
                    Metrics[`${prefix}F18_24`].id,
                    Metrics[`${prefix}M18_24`].id
                ]
            },
            {
                label: '25-34',
                metrics: [
                    Metrics[`${prefix}F25_34`].id,
                    Metrics[`${prefix}M25_34`].id
                ]
            },
            {
                label: '35-44',
                metrics: [
                    Metrics[`${prefix}F35_44`].id,
                    Metrics[`${prefix}M35_44`].id
                ]
            },
            {
                label: '45-54',
                metrics: [
                    Metrics[`${prefix}F45_54`].id,
                    Metrics[`${prefix}M45_54`].id
                ]
            },
            {
                label: '55-64',
                metrics: [
                    Metrics[`${prefix}F55_64`].id,
                    Metrics[`${prefix}M55_64`].id
                ]
            },
            {
                label: '65+',
                metrics: [
                    Metrics[`${prefix}F65_PLUS`].id,
                    Metrics[`${prefix}M65_PLUS`].id
                ]
            }
        ];

        _.each(groups, function (group) {
            group.metrics = _.map(group.metrics, function (concept) {
                return {
                    concept: concept,
                    companyId: companyId
                };
            });
        });

        return groups;
    }

    const DistributionChart = RivalIQ.graph.Distribution.extend({
        getHeight: function () {
            const me = this;
            return me.getOption('height') || 200;
        }
    });

    const Distribution = RivalIQ.apps.Dashboard.widgets.Distribution.extend({
        chartType: DistributionChart,

        ui: {
            noDataContainer: '.x-no-data-msg',
            information: '.fa-info-circle',
            popovers: '[data-toggle="popover"]',
            hideOnNoData: '.hide-no-data',
            incompleteDataMsg: '.data-incomplete-msg'
        },

        dashboardModelEvents: {
            'change:timePeriod': 'reload'
        },

        template: '#widgetInsightsAgeGenderTemplate',

        className: function () {
            const me = this;
            const className = me.dashboardModel.distributionClassName || '';
            return `${className} chart widget-insights-demographics`;
        },

        serializeData: function () {
            const me = this;
            const timePeriod = me.getProp('timePeriod');

            const notEnoughDataDescription = App.utils.getNotEnoughDataDescription(me.dashboardModel, me.dataWarning, timePeriod);

            return {
                metricLabel: me.dashboardModel.getMetricLabel(),
                exportHeightClass: me.dashboardModel.isExportingPPT() ? 'no-data-msg-container-export' : '',
                notEnoughDataDescription: notEnoughDataDescription
            };
        },

        getIncompleteDataMessage: function () {
            const me = this;
            const timePeriod = me.getProp('timePeriod');

            const notEnoughDataDescription = App.utils.getNotEnoughDataDescription(me.dashboardModel, me.dataWarning, timePeriod);
            me.ui.popovers.attr('data-content', notEnoughDataDescription);

            return notEnoughDataDescription;
        },

        getChartAttributes: function () {
            const me = this;

            const attrs = RivalIQ.apps.Dashboard.widgets.Distribution.prototype.getChartAttributes.apply(me, arguments);

            // The chart will be empty iff every bar in the chart has null as the value.
            const isEmpty = _.every(attrs.data, function (group) {
                return _.every(group, function (segment) {
                    return _.isNull(segment.value);
                });
            });
            me.isEmpty = isEmpty;

            return attrs;
        },

        onBeforeShowChart: function () {
            const me = this;

            const notEnoughDataDescription = me.getIncompleteDataMessage();
            if (me.isEmpty) {
                me.ui.noDataContainer.removeClass('hide');
                me.ui.hideOnNoData.addClass('hide');
            } else {
                me.ui.noDataContainer.addClass('hide');
                me.ui.hideOnNoData.removeClass('hide');
                if (!notEnoughDataDescription) {
                    me.ui.incompleteDataMsg.addClass('hide');
                }
            }

            me.ui.popovers.popover({
                html: true,
                trigger: 'hover'
            });
        }
    });

    const AgeGenderWidget = RivalIQ.apps.Dashboard.models.Widget.mixin({
        mixins: {
            InsightsExportTitle: App.widgets.InsightsExportTitle
        },

        scheduledExportAdvancedSettingsEnabled: false,
        view: Distribution,
        viewMore: false,
        getMetricLabel: function () {
            const me = this;
            let metricLabel;

            switch (me.metricGroupType) {
                case 'page_reach_age_gender':
                    metricLabel = RivalIQ.strings.facebook_insights_page_reach_age_gender_label;
                    break;
                case 'insta_followers':
                    metricLabel = RivalIQ.strings.instagram_insights_age_gender_distribution_metric_label;
                    break;
                default:
                    metricLabel = RivalIQ.strings.facebook_insights_age_gender_metric_label_avg_daily_impressions;
                    break;
            }

            return metricLabel;
        },
        getMetricGroups: function () {
            const me = this;
            return getMetricGroups(me.getProp('companyId'), me.metricGroupType);
        },
        propsToSerializeForExport: []
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSIGHTS_AGE_GENDER_DISTRIBUTION, AgeGenderWidget);

});
